import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormArray, Validators, UntypedFormBuilder } from '@angular/forms';

import { ApiMailTitle } from '../../api-client-module';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';

export interface MultiMailTitleDialogData {
  mail_titles?: ApiMailTitle[];
}

@Component({
  selector: 'app-multi-mail-title-dialog',
  templateUrl: './multi-mail-title-dialog.component.html',
  styleUrls: ['./multi-mail-title-dialog.component.css'],
  standalone: false,
})
export class MultiMailTitleDialogComponent implements OnInit {

  //名称×言語数
  mailTitles: ApiMailTitle[] = [];
  mailTitlesFormGroup!: FormGroup;
  mailTitlesArrayControl!: FormArray;
  projectLanguages!: Array<ProjectLanguage>;
  currentLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<MultiMailTitleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultiMailTitleDialogData,
    private formBuilder: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.mailTitles = this.data.mail_titles!;
    if (!this.mailTitles) {
      this.mailTitles = [];
    }
    this.currentLang = this.translate.currentLang;
    this.createForm();
    this.mailTitlesArrayControl = this.mailTitlesFormGroup.get('mailTitles') as FormArray;
  }

  //名称フォーム×言語数
  private createForm() {
    let arrayControl = this.formBuilder.array([]);
    let index: number = 0;
    let isAutoAllTrans: boolean = this.mailTitles.length > 0 ? true : false;
    for (const projectLanguage of this.projectLanguages) {
      let auto_trans = false;
      let mail_title = '';
      let trans_mail_title = '';
      for (const value of this.mailTitles) {
        if (projectLanguage.lang_code === value.lang_code) {
          if (!value.auto_trans && index !== 0) {
            isAutoAllTrans = false;
          }
          auto_trans = value.auto_trans ? value.auto_trans : false;
          mail_title = value.mail_title;
          trans_mail_title = value.trans_mail_title;
          break
        }
      }
      let _dict = {};
      if (index === 0) {
        _dict = {
          autoTrans: [auto_trans],
          mailTitle: [mail_title, [Validators.required]],
          transMailTitle: [trans_mail_title],
        }
      } else {
        _dict = {
          autoTrans: [auto_trans],
          mailTitle: [mail_title],
          transMailTitle: [],
        }
      }
      arrayControl.push(this.formBuilder.group(_dict));
      index++;
    }
    this.mailTitlesFormGroup = this.formBuilder.group(
      {
        autoAllTrans: [isAutoAllTrans],
        mailTitles: arrayControl
      }
    );
  }

  //更新ボタン
  addMailTitles(): void {
    if (this.mailTitlesFormGroup.valid) {
      let mailTitles = [];
      for (const index in this.projectLanguages) {
        const ctrl = this.mailTitlesArrayControl.controls[index];
        mailTitles.push(
          {
            auto_trans: ctrl.get('autoTrans')!.value,
            lang_code: this.projectLanguages[index].lang_code,
            mail_title: ctrl.get('mailTitle')!.value,
            trans_mail_title: ctrl.get('transMailTitle')!.value,
          }
        )
      }
      this.mailTitles = mailTitles;
      this.dialogRef.close(this.mailTitles);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  //全言語自動翻訳
  onChangeAutoAllTrans(): void {
    const isAutoAllTrans = this.mailTitlesFormGroup.get('autoAllTrans')!.value;
    for (const mailTitle of this.mailTitlesArrayControl.controls) {
      mailTitle.get('autoTrans')!.setValue(isAutoAllTrans);
    }
    this.mailTitlesArrayControl.controls[0].get('autoTrans')!.setValue(false);
  }

  //言語別自動翻訳
  onChangeAutoTrans(): void {
    let isAutoAllTrans: boolean = true;
    let index = 0;
    for (const mailTitle of this.mailTitlesArrayControl.controls) {
      if (!mailTitle.get('autoTrans')!.value && index !== 0) {
        isAutoAllTrans = false;
        break;
      }
      index++
    }
    this.mailTitlesFormGroup.get('autoAllTrans')!.setValue(isAutoAllTrans);
  }

}
